module.exports = __webpack_public_path__ + "static/img/gpt32.9f5b503b.jpg";